import React from 'react';
import './instagram-preview.css';

const posts = [
  {
    id: 1,
    type: 'INTRO',
    title: 'YOONIX.SHOP',
    subtitle: 'Запуск витрины цифровых продуктов',
    text: 'Боты, сайты и готовые решения для бизнеса. Быстро, красиво, по делу.'
  },
  {
    id: 2,
    type: 'WHY',
    title: 'Почему мы',
    subtitle: 'Скорость + стиль + результат',
    text: 'Готовые продукты с демо-доступом. Смотри перед покупкой.'
  },
  {
    id: 3,
    type: 'BOT',
    title: 'Telegram Bots',
    subtitle: 'Автоматизация продаж и сервиса',
    text: 'Боты для заявок, оплат, уведомлений и поддержки 24/7.'
  },
  {
    id: 4,
    type: 'WEB',
    title: 'Web Projects',
    subtitle: 'Лендинги и каталоги',
    text: 'Современные интерфейсы с акцентом на конверсию и скорость.'
  },
  {
    id: 5,
    type: 'DESIGN',
    title: 'Design Pack',
    subtitle: 'Визуал под ваш бренд',
    text: 'Баннеры, карточки, обложки и UI-наборы для запуска рекламы.'
  },
  {
    id: 6,
    type: 'SCRIPT',
    title: 'Scripts & Tools',
    subtitle: 'Полезные скрипты',
    text: 'Автоматизируем рутину: парсинг, отчёты, интеграции API.'
  },
  {
    id: 7,
    type: 'DB',
    title: 'Data & DB',
    subtitle: 'Надёжная база для роста',
    text: 'Готовые структуры БД и быстрый старт для ваших проектов.'
  },
  {
    id: 8,
    type: 'CASE',
    title: 'Кейс: x2 лидов',
    subtitle: 'Через автоворонку в Telegram',
    text: 'Настроили цепочку сообщений и сократили ручную работу в 3 раза.'
  },
  {
    id: 9,
    type: 'CTA',
    title: 'Нужен свой проект?',
    subtitle: 'Соберём решение под задачу',
    text: 'От идеи до запуска: архитектура, дизайн, разработка и поддержка.'
  },
  {
    id: 10,
    type: 'CONTACT',
    title: 'Связь',
    subtitle: '@yoonix_shop',
    text: 'Напишите в Telegram, отправим демо и предложим лучший формат.'
  }
];

function InstagramPreview() {
  return (
    <div className="ig-preview-page">
      <div className="grid-bg"></div>

      <header className="ig-preview-header">
        <h1>Instagram Preview // YOONIX.SHOP</h1>
        <p>Макеты 1:1 для первых публикаций — можно сразу делать скриншоты.</p>
      </header>

      <section className="ig-post-grid">
        {posts.map((post) => (
          <article className="ig-post" key={post.id}>
            <div className="ig-post-top">
              <span className="ig-post-type">{post.type}</span>
              <span className="ig-post-id">#{String(post.id).padStart(2, '0')}</span>
            </div>

            <div className="ig-post-content">
              <h2>{post.title}</h2>
              <h3>{post.subtitle}</h3>
              <p>{post.text}</p>
            </div>

            <div className="ig-post-bottom">yoonix.shop</div>
          </article>
        ))}
      </section>
    </div>
  );
}

export default InstagramPreview;
